import type { ElementWithUserNames } from '../types/element.types';
import { ElementType } from '../types/element.types';
import { sortElements } from './elementSortUtils';

/** 与 ElementsTable.css 中 .element-cell / 分类行高度一致 */
export const ELEMENT_TABLE_ROW_HEIGHT_PX = 24;

export type ElementColumnCell =
  | ElementWithUserNames
  | { isCategoryHeader: true; categoryType: ElementType };

/**
 * 分类标题与元素各占一行，与 SceneDetails 表格行数一致。
 */
export function countRowsWithCategoryHeaders(sortedItems: ElementWithUserNames[]): number {
  let count = 0;
  let previousType: ElementType | undefined;
  for (const item of sortedItems) {
    if (item.elementType !== previousType) {
      count += 1;
      previousType = item.elementType!;
    }
    count += 1;
  }
  return count;
}

export function totalSlotsForElements(elements: ElementWithUserNames[]): number {
  return countRowsWithCategoryHeaders(sortElements(elements));
}

/** 三列从左到右、列优先填满时，单列至少需要的行数 */
export function rowsPerColumnFromTotalSlots(totalSlots: number): number {
  return Math.max(1, Math.ceil(totalSlots / 3));
}

/**
 * 与 SceneDetails 内「场次元素」三列布局一致：先插入分类头，再按列优先分为三列。
 */
export function buildElementColumnsThreeWay(
  sortedItems: ElementWithUserNames[]
): ElementColumnCell[][] {
  const itemsWithHeaders: ElementColumnCell[] = [];
  let previousType: ElementType | undefined = undefined;

  sortedItems.forEach((item) => {
    if (item.elementType !== previousType) {
      itemsWithHeaders.push({
        isCategoryHeader: true,
        categoryType: item.elementType!,
      });
      previousType = item.elementType;
    }
    itemsWithHeaders.push(item);
  });

  const totalSlots = itemsWithHeaders.length;
  const rowsPerColumn = rowsPerColumnFromTotalSlots(totalSlots);
  const columns: ElementColumnCell[][] = [[], [], []];

  itemsWithHeaders.forEach((item, index) => {
    const columnIndex = Math.floor(index / rowsPerColumn);
    if (columnIndex < 3) {
      columns[columnIndex].push(item);
    }
  });

  return columns;
}
